module.exports = __webpack_public_path__ + "static/assets/fc30085c3e3b463924101f8150ebdc2e.svg";